import "core-js/modules/es.number.constructor.js";
//@ts-ignore
import BaseFloatingLabel from "@vueEntry/UIKitComponents/BaseFloatingLabel.vue";
//@ts-ignore
import { useFloatingLabel } from "@wkComposables/UIKit/useFloatingLabel";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseInput",
  components: {
    BaseFloatingLabel: BaseFloatingLabel
  },
  inheritAttrs: false,
  props: {
    inputClass: {
      type: [String, Array],
      required: false,
      "default": ""
    },
    inputType: {
      type: String,
      "default": "text-input"
    },
    labelText: {
      type: String,
      "default": ""
    },
    border: {
      type: Boolean,
      "default": true
    },
    radius: {
      type: Boolean,
      "default": true
    },
    modelValue: {
      type: [String, Number]
    },
    feedback: {
      type: Object
    },
    isValid: {
      type: Boolean,
      "default": null
    },
    auto: {
      type: Boolean,
      "default": true
    },
    keepFloatingLabel: {
      type: Boolean,
      "default": false
    },
    formatter: {
      type: Object,
      "default": null
    }
  },
  emits: ["update:modelValue", "click", "keydown-enter-pressed", "focusin", "focusout", "keydown"],
  setup: function setup(props, context) {
    var _useFloatingLabel = useFloatingLabel(context.emit),
      labelState = _useFloatingLabel.labelState,
      setInitialLabelState = _useFloatingLabel.setInitialLabelState,
      handleFocusIn = _useFloatingLabel.handleFocusIn,
      handleFocusOut = _useFloatingLabel.handleFocusOut,
      setInlineLabel = _useFloatingLabel.setInlineLabel,
      setFloatingLabel = _useFloatingLabel.setFloatingLabel;
    return {
      labelState: labelState,
      setInitialLabelState: setInitialLabelState,
      handleFocusIn: handleFocusIn,
      handleFocusOut: handleFocusOut,
      setInlineLabel: setInlineLabel,
      setFloatingLabel: setFloatingLabel
    };
  },
  data: function data() {
    return {
      type: "",
      //a valid input type
      feedbackObj: {},
      pointerDownListener: function pointerDownListener(e) {
        e.preventDefault();
      }
    };
  },
  computed: {
    passwordIcon: function passwordIcon() {
      return document.querySelector("[data-type='password-icon']");
    }
  },
  watch: {
    feedback: function feedback(cur, prev) {
      this.normalizeFeedbackProp();
    },
    modelValue: function modelValue(cur, prev) {
      /* In this scenario, the cur had been resetted and before that, it had some truthy value */
      if (cur) {
        var baseInputEl = this.$refs.baseInput;
        if (!baseInputEl) return;
        /* Syncing the inputValue with the modelValue */
        if (!baseInputEl.value && this.formatter) cur = baseInputEl.value;
        var unFormattedValue = this.updateInputValue(baseInputEl, cur);
        this.$emit("update:modelValue", unFormattedValue);
      } else {
        this.$refs.baseInput.value = "";
      }
      if (cur != null && "".concat(cur).length > 0 && this.auto && this.labelState !== "floating-label") this.labelState = "floating-label";else if (cur == null || cur == undefined) this.labelState = "inline-label";
    },
    //Manually moving the floating label
    keepFloatingLabel: function keepFloatingLabel(cur, prev) {
      if (!cur) {
        this.handleFocusOut(this.modelValue, true, this.auto);
      } else this.setFloatingLabel();
    }
  },
  created: function created() {
    this.type = this.$attrs.type;
    this.normalizeFeedbackProp();
    this.setInitialLabelState(this.modelValue);
  },
  mounted: function mounted() {
    if (this.modelValue != null || this.modelValue != undefined) {
      this.$refs.baseInput.value = "".concat(this.modelValue);
    }
    if (this.formatter) {
      //In case the prop has to be formatted, we do it!!!
      var unFormattedValue = this.updateInputValue(this.$refs.baseInput, "".concat(this.modelValue));
      this.$emit("update:modelValue", unFormattedValue);
    }
    this.setPointerOutListener();
  },
  unmounted: function unmounted() {
    var _a;
    (_a = this.passwordIcon) === null || _a === void 0 ? void 0 : _a.removeEventListener("pointerdown", this.pointerDownListener);
  },
  methods: {
    select: function select() {
      this.$refs.baseInput.select();
    },
    /**
     * Prevents the default behaviour of pointerout so the clicked element won't make lose the focus to the input element
     * */
    setPointerOutListener: function setPointerOutListener() {
      if (this.$attrs.type !== "password") return;
      var el = this.passwordIcon;
      if (!el) return;
      el.addEventListener("pointerdown", this.pointerDownListener);
    },
    handleFloatingLabelClick: function handleFloatingLabelClick() {
      this.$refs.baseInput.focus(); //Focusing the input!
    },
    normalizeFeedbackProp: function normalizeFeedbackProp() {
      if (!this.feedback) return;
      this.feedbackObj = this.feedback;
      if (this.feedback.valid && typeof this.feedback.valid === "string") this.feedbackObj.valid = [this.feedback.valid];
      if (this.feedback.invalid && typeof this.feedback.invalid === "string") this.feedbackObj.invalid = [this.feedback.invalid];
    },
    updateInputValue: function updateInputValue(inputEl, value) {
      //In this case the baseInput has been cleaned up
      if (!value) {
        inputEl.value = "";
        return "";
      }
      var unFormattedValue = "";
      if (this.formatter && this.formatter.unFormatFn) unFormattedValue = "".concat(this.formatter.unFormatFn(value));else unFormattedValue = value;
      if (this.formatter)
        //In case there is a formatter, I will format the inputValue!
        inputEl.value = this.formatter.formatFn(unFormattedValue);else inputEl.value = unFormattedValue;
      return unFormattedValue;
    },
    handleInputChange: function handleInputChange(_ref) {
      var target = _ref.target;
      //The baseSelect updates its value via prop (so its update can be found in the value watcher)
      if (this.inputType === "select") return;
      var targetEl = target;
      var unFormattedValue = this.updateInputValue(targetEl, targetEl.value);
      this.$emit("update:modelValue", unFormattedValue);
    },
    handleClick: function handleClick(e) {
      this.$emit("click", e);
    },
    handleClean: function handleClean() {
      //Cleaning up the input!
      this.$emit("update:modelValue", "");
      this.setInlineLabel();
    },
    handleShowPasswd: function handleShowPasswd(e) {
      if (this.type === "password") {
        this.type = "text";
      } else if (this.type === "text") {
        this.type = "password";
      }
    }
  }
});